import React, {useEffect, useState} from 'react';

import Box from "@mui/material/Box";
import Moment from "react-moment";
import {IAttendee} from "./Buxliest";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from '@mui/icons-material/Delete';
import axios, {AxiosPromise} from "axios";
import Config from "../../utils/Config";

export interface IAttendeesEventListItemProps {
  attendee: IAttendee;
  removeSuccessCallback: () => void,
}

const AttendeesEventListItem = (props: IAttendeesEventListItemProps) => {

  const deleteAttendee = () : AxiosPromise => {
    return axios({
      url: Config.getDrupalVar('path.baseRoot') + Config.getDrupalVar('path.baseUrl') + 'jsonapi/bux_attendee/bux_attendee/' + props.attendee.id,
      params: {
      },
      data: {
      },
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
      },
    });
  }

  const handleClick = () => {
    deleteAttendee().then((response) => {
      console.log('response delete item', response);
      props.removeSuccessCallback();
    })
  };


  return (
    <>
      <Box className="flex flex-row justify-between items-center">
        <Box>
          <Box className="text-xl text-primary-500">
            <Moment format="HH:mm U\hr" parse="YYYY-MM-DDTHH:mm:ss">
              {props.attendee.event.event_date.value}
            </Moment>
          </Box>
          <Box
            className="text-xl font-semibold">{props.attendee.event.title}</Box>
          <Box className="italic">{props.attendee.event.schedule.place.title}</Box>
          <Box className="text-gray-500">Person: {props.attendee.field_address.given_name} {props.attendee.field_address.family_name}</Box>
          {props.attendee.remark && (
            <Box className="text-gray-500">Anmerkung: {props.attendee.remark}</Box>
          )}
        </Box>
        <Box>
          <IconButton aria-label="delete" onClick={handleClick}>
            <DeleteIcon/>
          </IconButton>
        </Box>
      </Box>
    </>
  );
};
export default AttendeesEventListItem;
